<template>
    <div>
        <div class="form-group " v-show="focus">
            <label :for="name" v-if="!hideLabel">{{label}}</label>
            <textarea @resize="alert()" v-validate="rules" @blur="focus=false" ref="input"
                      @input="inputValue"
                      :id="name"
                      type="text"

                      :data-vv-as="label"
                      :placeholder="placeholder"
                      class="form-control"
                      :class="{'is-invalid':errors.has(name)}"
                      :name="name">{{value}}</textarea>
            <div v-if="errors.has(name)" class="invalid-feedback">
                {{errors.first(name)}}
            </div>
        </div>
        <div class="form-group " v-show="!focus">
            <label :for="name" v-if="!hideLabel">{{label}}</label>
            <div class="markdown-view" @click="setFocus">
                <vue-markdown :source="value"></vue-markdown>
            </div>
        </div>
    </div>
</template>

<script>

    import VueMarkdown from 'vue-markdown'
    import mixinField from '../../mixins/mixinField';

    export default {
        mixins: [mixinField],
        components: {
            VueMarkdown
        },
        methods: {
            setFocus(e) {
                this.focus = true;
                this.$nextTick(() => {
                    this.$refs.input.focus();
                })
            }
        },
        name: "FieldMarkdown",
        data() {
            return {
                focus: false,
                rules: ""
            }
        },


    }
</script>

<style scoped>

    .markdown-view {
        min-height: 100px;
        display: block;
        width: 100%;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }
</style>


// WEBPACK FOOTER //
// src/components/fields/FieldMarkdown.vue